import { googleReviews } from "@/mocks/reviews";

type Review = (typeof googleReviews)[number];

export default function GoogleReviewCard({ review }: { review: Review }) {
  return (
    <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
      <header className="flex items-start gap-3">
        <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full">
          {review.avatarType === "photo" ? (
            <img
              src={review.image}
              alt={review.name}
              title={`${review.name} Google review`}
              className="h-full w-full object-cover object-top"
            />
          ) : (
            <span
              className="flex h-full w-full items-center justify-center font-heading text-base font-semibold text-white"
              style={{ backgroundColor: review.avatarColor }}
              aria-hidden="true"
            >
              {review.initial}
            </span>
          )}
        </span>
        <div className="min-w-0 flex-1">
          <span className="block truncate font-heading text-sm font-semibold text-foreground-950">{review.name}</span>
          <span className="block text-xs text-foreground-500">{review.meta}</span>
        </div>
        <i className="ri-google-fill text-lg text-foreground-300" aria-hidden="true" />
      </header>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <span className="flex gap-0.5 text-secondary-500" aria-label={`${review.rating} out of 5 stars`}>
          {Array.from({ length: review.rating }).map((_, index) => (
            <i key={index} className="ri-star-fill text-sm" aria-hidden="true" />
          ))}
        </span>
        <span className="text-xs text-foreground-500">{review.timeAgo}</span>
        {review.isNew && (
          <span className="rounded-full border border-background-300 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-foreground-600">
            New
          </span>
        )}
      </div>

      <blockquote className="mt-3 whitespace-pre-line text-sm leading-relaxed text-foreground-700">
        {review.quote}
      </blockquote>
    </figure>
  );
}